import { createContext } from 'react';

import shadowland from '../tenants/shadowland.json';
import example from '../tenants/example.json';
import oklahoma from '../tenants/oklahoma.json';
import { resolveTenantIdForLocation } from './tenantResolution';

const TENANTS = {
  shadowland,
  example,
  oklahoma,
};

function safeSessionStorage() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function resolveTenantId() {
  return resolveTenantIdForLocation({
    tenants: TENANTS,
    envTenant: import.meta.env.VITE_TENANT,
    domainMapRaw: import.meta.env.VITE_TENANT_DOMAIN_MAP,
    demoTokenMapRaw: import.meta.env.VITE_TENANT_DEMO_TOKEN_MAP,
    demoTokens: {
      oklahoma: import.meta.env.VITE_OKLAHOMA_DEMO_TOKEN,
      VITE_OKLAHOMA_DEMO_TOKEN: import.meta.env.VITE_OKLAHOMA_DEMO_TOKEN,
    },
    hostname: window.location.hostname,
    pathname: window.location.pathname,
    storage: safeSessionStorage(),
  });
}

const activeTenantId = resolveTenantId();
export const tenant = TENANTS[activeTenantId] || TENANTS.shadowland;
export const TenantContext = createContext(tenant);
